import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import Home from "./Home";
import Comics from "./Comics";
import ViewChapter from "./ViewChapter";

const root = ReactDOM.createRoot(document.getElementById('root'));
const router = createBrowserRouter([
    {
        path: "/truyen-tranh/:comicId",
        element:<Comics/> ,
    },
    {
        path: "/manga/:name/:chapter",
        element:<ViewChapter/> ,
    },
    {
        path: "/truyen-tranh/:name/:chapter/:code",
        element:<ViewChapter/> ,
    },
    {
        path: "/truyen-tranh/:name/:nameCode",
        element:<ViewChapter/> ,
    },
    {
        path: "/:path/",
        element:<Home/> ,
    },
    {
        path: "/:path/:subPath",
        element:<Home/> ,
    },
    {
        path: "/home",
        element: <Home/>,
    },
    {
        path: "/",
        element: <Home/>,
    },
]);

root.render(
    <React.StrictMode>
        <RouterProvider router={router}/>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
